import { render, staticRenderFns } from "./TopicArticle.vue?vue&type=template&id=875a3e54&scoped=true&"
import script from "./TopicArticle.vue?vue&type=script&lang=js&"
export * from "./TopicArticle.vue?vue&type=script&lang=js&"
import style0 from "./TopicArticle.vue?vue&type=style&index=0&id=875a3e54&scoped=true&lang=css&"
import style1 from "./TopicArticle.vue?vue&type=style&index=1&id=875a3e54&lang=less&scoped=true&"
import style2 from "./TopicArticle.vue?vue&type=style&index=2&id=875a3e54&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875a3e54",
  null
  
)

export default component.exports